import vuex from 'vuex'
import Vue from 'vue'
Vue.use(vuex)

const barra = {
    namespaced: true,
    state: {
        botones: [
            { caption: "General", state: true, disabled:false, id: 1 , color:"primary", reduce:"G", tool:"Corresponde al avance acumulado a la fecha."},            
            { caption: "Por periodo", state: false, disabled:false, id: 2, color:"secondary" , reduce:"C" , tool:"" },
            { caption: "Por vigencia", state: false, disabled:false, id: 3 , color:"secondary", reduce:"V", tool:"Indicadores en ejecución en el año consultado"}
        ],
        botonactual: 1  
        , 
        idperiodo : 0     
    },
    actions: {
        aseleccionar({commit}, payload) {
            commit('SET_ACTUAL', payload.botonnuevo)        
        },
        put_periodo({commit}, payload) {
            commit('SET_PERIODO', payload.idperiodo)        
        },
        setstate({commit}, payload){
            commit('SET_DISABLED', payload.boton)        
        }
    },
    mutations: {
        SET_ACTUAL(state, botonnuevo) {
            state.botones[state.botonactual-1].state = false
            state.botones[state.botonactual-1].color = "secondary"
            state.botonactual = botonnuevo
            state.botones[state.botonactual-1].state = true
            state.botones[state.botonactual-1].color = "primary"

        },
        SET_PERIODO(state, periodonuevo) {           
            state.idperiodo = periodonuevo          
        },
        SET_DISABLED(state, boton) {   
            if(boton == 0)
            {
                state.botones.forEach(element => {
                    element.disabled = false;
                });
            }else
            {
                state.botones[boton-1].disabled = true
            }
        }
    },
    getters: {
        gbotones(state) {
            return state.botones
        },
        gcomparativa(state) {
            return state.botones.filter(p=> p.id>1)
        }
        ,
        gperiodo(state)
        {
            return state.idperiodo
        }
    }
}

export default barra;
